import { useSearchParams, Link } from 'react-router-dom'
import { AlertTriangle, RefreshCcw, Home } from 'lucide-react'
import { PageShell } from '@/components/common/PageShell'
import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'

/**
 * Error page for displaying API or application errors.
 * Route: /#/error
 */
export function ErrorPage() {
  const [searchParams] = useSearchParams()
  const message = searchParams.get('message') ?? 'Something went wrong'
  const details = searchParams.get('details')

  const handleRetry = () => {
    // Go back in history, or to dashboard if no history
    if (window.history.length > 2) {
      window.history.back()
    } else {
      window.location.href = '/#/'
    }
  }

  return (
    <PageShell>
      <div className="flex items-center justify-center min-h-[60vh] p-6">
        <Card className="max-w-md w-full border-0 shadow-lg">
          <CardContent className="pt-8 pb-8">
            <div className="text-center space-y-6">
              {/* Icon */}
              <div className="mx-auto w-16 h-16 rounded-2xl bg-destructive/10 border border-destructive/20 flex items-center justify-center">
                <AlertTriangle className="h-8 w-8 text-destructive" />
              </div>

              {/* Message */}
              <div className="space-y-2">
                <h1 className="text-xl font-semibold">{message}</h1>
                {details && (
                  <p className="text-sm text-muted-foreground">
                    Error: {details}
                  </p>
                )}
              </div>

              {/* Actions */}
              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <Button onClick={handleRetry} variant="outline">
                  <RefreshCcw className="h-4 w-4 mr-2" />
                  Retry
                </Button>
                <Button asChild>
                  <Link to="/">
                    <Home className="h-4 w-4 mr-2" />
                    Go to Dashboard
                  </Link>
                </Button>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </PageShell>
  )
}

export default ErrorPage
